import axios from "axios";
import moment from "moment";

export default {
    data() {
        return {
                //Timer
      TimerObject: {}
        }
    },

    methods: {
    datePickerPR() {
        const self = this;
        $('input[name="daterangePR"]').daterangepicker(
            {
                opens: "left",
            },
            function (start, end) {
                self.startDatePR = new Date(start);
                self.endDatePR = new Date(end);
                self.initDatePR =
                    self.dateToMDY(self.startDatePR) +
                    " - " +
                    self.dateToMDY(self.endDatePR);
            }
        );
    },

             //Timer
 StartLogoutTime() {
    this.TimerObject = setTimeout(() => {
      this.AutoLogout();
    }, 1.8e+6);
  },
 ResetLogoutTime(){
    clearTimeout(this.TimerObject);
        this.TimerObject = setTimeout(() => {
         this.AutoLogout();
        }, 1.8e+6);
  },

        loadInit() {
            const dd = new Date();
            dd.setDate(dd.getDate() - 30);

            this.startDatePR = dd;
            this.endDatePR = new Date();
            this.initDatePR =
                this.dateToMDY(this.startDatePR) +
                " - " +
                this.dateToMDY(this.endDatePR);

            this.StartLogoutTime();
            this.fetchInitData();
        },

        fetchInitData() {
            this.intDummyComm();
            if (this.selectedUsers.length > 0) {
                let aa = [];
                for (let i = 0; i < this.selectedUsers.length; i++)
                    aa.push(this.users[this.selectedUsers[i]].id);
                this.dummyComm.extras = aa.toString();
                //alert(this.selectedUsers.toString() + "    "+this.dummyComm.extras)
            } else this.dummyComm.extras = "";

            if (this.selectedPractice + "".length > 0) {
                this.dummyComm.extras1 = this.selectedPractice;
            } else this.dummyComm.extras1 = "";

            if (this.initDatePR.length > 0) {
                this.dummyComm.myDate = this.dateToSqlServerDateFormat(
                    this.startDatePR
                );
                this.dummyComm.myTime = this.dateToSqlServerDateFormat(this.endDatePR);
            } else {
                this.dummyComm.myDate = null;
                this.dummyComm.myTime = null;
            }

            //this.payments=[];
            //this.dummyComm.extras = "";
            const url = this.SERVER + "/VNSPRAAPI/Reports/StatisticReportInitData";

            this.axiosGetData(url, 1);

            this.$nextTick(() => {
                $("#table001").DataTable().destroy();
                $("#table001").DataTable({
                    pageLength: 50,
                    lengthMenu: [
                      [50, 100, 500, 1000, 2000, -1],
                      [50, 100, 500, 1000, 2000],
                    ],
                    buttons: ["copy", "csv", "excel", "pdf", "print"],
                });
                $(
                    ".buttons-copy, .buttons-csv, .buttons-print, .buttons-pdf, .buttons-excel"
                ).addClass("btn btn-primary mr-1");
                $(".table001").DataTable().draw();
            }); // this.$nextTick
        },

        //------------------------------------------ Common Methods
        async axiosGetData(myUrl, what) {
            var loader = this.$loading.show({
                // Optional parameters
                  color: '#03a9f3'
                });
            await axios({
                method: "post",
                url: myUrl,
                data: this.dummyComm, headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
            })
                .then((res) => {
                    loader.hide();
                    // if everything goes well -- we will get data
                    this.lastErrorCode = 1;
                    if (what === 1) {
                        console.log(res.data);
                        this.users = res.data.users;
                        this.practices = res.data.practices;
                        this.inData = res.data.outData;
                    }
                })
                .catch(function (error) {
                    if (error.response) {
                        this.lastErrorCode = 1;
                        alert("-> " + error.response.data);
                        alert("-> " + error.response.status);
                        alert("-> " + error.response.headers);
                    } else if (error.request) {
                        this.lastErrorCode = 1;
                        alert("No response " + error.request);
                    } else {
                        this.lastErrorCode = 1;
                        alert("Error", error.message);
                    }
                })
                .finally(() => {
                    this.ResetLogoutTime();
                    loader.hide(); 
             });
        }, // axiosGetData

    }, // end methods

    watch: {
        initDatePR: function () {
            this.fetchInitData();
        },

        selectedUsers: function () {
            this.fetchInitData();
        },

        selectedPractice: function () {
            this.fetchInitData();
        },

        users: function (val) {
            this.usersList = [];
            for (let i = 0; i < val.length; i++) {
                this.usersList.push(val[i].name);
            }
        },

        practices: function() {
            this.practices.unshift({value:-99,label:""});
        },

        inData: function () {
            let obj = this.inData;
            let kount = 0;
           //debugger
            for (let i = 0; i < obj.length; i++) {
                let dd = new Date(obj[i].dos);
                obj[i].dosStr = moment(String(dd)).format("dddd Do MMM YYYY");

                kount += obj[i].visits;
            }

            for (let i = 0; i < obj.length; i++) {
                obj[i].percentage = ((obj[i].visits / kount) * 100).toFixed(1);
            }
        },

    }, // watch

    mounted(){
        if(this.$store.getters.getAuthToken==="")
    {
        this.$store.commit('setAuthToken',localStorage.BeToken);
    }
        this.loadInit();
    }, // mounted
    unmounted() {
        clearTimeout(this.TimerObject);
      },
}